module.exports = __webpack_public_path__ + "media/images/equipment-9d2ca063b6adf05c5498add598fcfc5d.svg";